import React, { Component } from 'react'

import './PublicPhotos.css'

/**
 * Modules
 */
import { Modal } from 'antd'
import { getPhotoGallery } from '../../utils/photoGalleryFunctions';

/* Components */
import PublicPhotosView from './PublicPhotosView';

class PublicPhotos extends Component {

	constructor(props) {
		super(props)

		this.state = {
			loading: true,
			arrayOfPhotos: [],
			photoDialog: false,
			userIsLogged: false,

			choosedPhoto: {
				title: '',
				img: ''
			}
		}
	}

	componentDidMount = () => {
		this.getAllPhotosFromDatabase();
	}

	getAllPhotosFromDatabase = async () => {
		/* Get all photos */
		let localArrayOfPhotos = await getPhotoGallery();
		this.setState({
			arrayOfPhotos: localArrayOfPhotos,
			loading: false,
		});
	}

	/**
	 * Methods to add and remove photos
	 */
	getPhoto = (file) => {
		this.setState({ loading: true })

		// let finalFile = file.target.files[0]

		// firebase.firestore().collection('photos').add({ title: finalFile.name.substring(0,finalFile.name.indexOf('.')), description: 'Descrição da foto' })
		// .then(photo => {
		// 	/* put photo in firebase storage */
		// 	firebase.storage().ref()
		// 	.child('photos/' + photo.id)
		// 	.put(finalFile, { contentType: 'image/jpeg' })
		// 	.then(() => {
		// 		this.getAllPhotosFromDatabase()
		// 	})
		// })
	}

	choosePhoto = () => {
		document.getElementById('selectPhoto').click()
	}

	removePhoto = (key) => {
		let _this = this

		Modal.confirm({
			title: 'Tem certeza que quer deletar essa foto?',
			content: 'Essa operação não poderá ser desfeita',
			okText: 'Sim',
			okType: 'danger',
			cancelText: 'Não',
			onOk() {
				_this.deletePhotoFromDatabase(key)
			}
		})
	}

	deletePhotoFromDatabase = (key) => {
		this.setState({ loading: true })

		// /* Remove from firebase database */
		// firebase.firestore().collection('photos').doc(key)
		// .delete()
		// .then(() => {
		// 	this.getAllPhotosFromDatabase()
		// })

		// /* Remove from firebase storage */
		// firebase.storage().ref()
		// .child('photos/' + key)
		// .delete()
	}

	openPhotoDialog = (index) => {
		this.setState({
			photoDialog: true,
			choosedPhoto: this.state.arrayOfPhotos[index]
		})
	}

	closePhotoDialog = () => {
		this.setState({ photoDialog: false })
	}

	render() {
		return (
			<PublicPhotosView
				arrayOfPhotos={this.state.arrayOfPhotos}
				userIsLogged={this.state.userIsLogged}
				loading={this.state.loading}
				photoDialog={this.state.photoDialog}
				choosedPhoto={this.state.choosedPhoto}

				openPhotoDialog={e => this.openPhotoDialog(e)}
				removePhoto={e => this.removePhoto(e)}
				getPhoto={e => this.getPhoto(e)}
				choosePhoto={() => this.choosePhoto()}
				closePhotoDialog={() => this.closePhotoDialog()}
			/>
		)
	}

}

export default PublicPhotos